/**
 *
 * QuestionMatrixCheckbox
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import FormGroup from '@material-ui/core/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlOption from './components/FormControlOption';

const useStyles = makeStyles({
  group: {
    margin: '8px 0',
  },
  matrix: {
    fontSize: 12,
    marginTop: 10,
    '& > thead > tr': {
      display: 'flex',
    },
    '& > thead > tr > th:first-child': {
      flex: '2',
    },
    '& > thead > tr > th': {
      flex: '1',
    },
    '& > tbody > tr': {
      display: 'flex',
    },
    '& > tbody > tr:nth-child(even)': {
      backgroundColor: '#F8F9F9',
    },
    '& > tbody > tr > td:first-child': {
      flex: '2',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      paddingLeft: 8,
    },
    '& > tbody > tr > td:first-child > div': {
      position: 'relative',
    },
    '& > tbody > tr > td': {
      flex: '1',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: 8,
      paddingBottom: 8,
    },
  },
  matrixQuestion: {
    marginTop: 16,
    fontSize: 16,
    fontWeight: 'bold',
  },
  matrixRadio: {
    padding: 0,
  },
});

function QuestionMatrixCheckbox({
  name,
  columns = [],
  rows,
  answers,
  onMatrixCheckboxChange,
}) {
  const classes = useStyles();

  if (columns.length < 4) {
    return (
      <table className={classes.matrix}>
        <thead>
          <tr>
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <th />
            {columns.map(col => (
              <th key={col.title}>{col.title}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map(row => (
            <tr key={`ROW-${row.value}`}>
              <td>{row.text}</td>
              {columns.map(col => {
                let checked = false;
                if (
                  answers &&
                  Array.isArray(answers[row.value]) &&
                  answers[row.value].includes(col.name)
                )
                  checked = true;
                return (
                  <td key={`ROW-${row.value}-COL-${col.name}`}>
                    <Checkbox
                      classes={{ root: classes.matrixRadio }}
                      checked={checked}
                      value={col.name}
                      onChange={e =>
                        onMatrixCheckboxChange(name, row.value, e.target.value)
                      }
                      inputProps={{ 'aria-label': `Radio ${row.value}` }}
                    />
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  return (
    <>
      <Hidden xsDown>
        <table className={classes.matrix}>
          <thead>
            <tr>
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <th />
              {columns.map(col => (
                <th key={col.title}>{col.title}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map(row => (
              <tr key={`ROW-${row.value}`}>
                <td>{row.text}</td>
                {columns.map(col => {
                  let checked = false;
                  if (
                    answers &&
                    Array.isArray(answers[row.value]) &&
                    answers[row.value].includes(col.name)
                  )
                    checked = true;
                  return (
                    <td key={`ROW-${row.value}-COL-${col.name}`}>
                      <Checkbox
                        classes={{ root: classes.matrixRadio }}
                        checked={checked}
                        value={col.name}
                        onChange={e =>
                          onMatrixCheckboxChange(
                            name,
                            row.value,
                            e.target.value,
                          )
                        }
                        inputProps={{ 'aria-label': `Radio ${row.value}` }}
                      />
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </Hidden>
      <Hidden smUp>
        {rows.map(row => (
          <React.Fragment key={row.text}>
            <Typography className={classes.matrixQuestion}>
              - {row.text}
            </Typography>
            <FormGroup className={classes.group}>
              {columns.map(col => {
                let checked = false;
                if (
                  answers &&
                  Array.isArray(answers[row.value]) &&
                  answers[row.value].includes(col.name)
                )
                  checked = true;
                return (
                  <FormControlOption
                    key={`ROW-${row.value}-COL-${col.name}`}
                    checked={checked}
                    value={col.name}
                    label={col.title}
                    onChange={e =>
                      onMatrixCheckboxChange(name, row.value, e.target.value)
                    }
                    type="checkbox"
                  />
                );
              })}
            </FormGroup>
          </React.Fragment>
        ))}
      </Hidden>
    </>
  );
}

QuestionMatrixCheckbox.propTypes = {
  name: PropTypes.string,
  columns: PropTypes.array,
  rows: PropTypes.array,
  answers: PropTypes.any,
  onMatrixCheckboxChange: PropTypes.func,
};

export default QuestionMatrixCheckbox;
